import { ReactElement, useContext } from "react"

import { Datasets } from "../../../../../constants/enums"
import useUploadDeviceAttachments from "../../../../../services/middleware/hooks/devices/common/useUploadDeviceAttachments"
import useUploadedDeviceAttachments from "../../../../../services/middleware/hooks/devices/common/useUploadedDeviceAttachments"
import Attachments, {
    IAttachmentsProps,
} from "../../../common/components/attachments/attachments"
import { TTRDeviceFormData } from "../../types/providerTypes"

const TTRAttachments = ({
    context,
}: IAttachmentsProps<TTRDeviceFormData>): ReactElement => {
    const {
        currentIndex,
        setCurrentIndex,
        formData,
        setFormData,
        deviceId,
        deviceRef,
        saveDraft,
        saveDraftLoading,
        attachmentUUID,
    } = useContext(context)

    const {
        uploadAttachments,
        error: uploadError,
        loading: attachmentUploadInProgress,
    } = useUploadDeviceAttachments(deviceRef, deviceId, attachmentUUID)

    const {
        uploadedAttachments,
        error: listAttachmentsError,
        isLoading: isLoadingUploadedAttachments,
        error: uploadedAttachmentsError,
        mutate: updateUploadedAttachments,
    } = useUploadedDeviceAttachments(Datasets.TTR, deviceRef, attachmentUUID)

    return (
        <Attachments<TTRDeviceFormData>
            isLct={false}
            dataset={Datasets.TTR}
            currentIndex={currentIndex}
            setCurrentIndex={setCurrentIndex}
            formData={formData}
            setFormData={setFormData}
            deviceRef={deviceRef}
            saveDraft={saveDraft}
            saveDraftLoading={saveDraftLoading}
            attachmentUUID={attachmentUUID}
            uploadAttachments={uploadAttachments}
            attachmentUploadInProgress={attachmentUploadInProgress}
            uploadedAttachments={uploadedAttachments}
            isLoadingUploadedAttachments={isLoadingUploadedAttachments}
            uploadedAttachmentsError={uploadedAttachmentsError}
            updateUploadedAttachments={updateUploadedAttachments}
            listAttachmentsError={listAttachmentsError}
            uploadError={uploadError}
        />
    )
}

export default TTRAttachments
